/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticlePaywall/SuccessfulPayment/theme';

export const ArticlePaywallSuccessfulPaymentTheme = theme;
